import axios from "../../API/apiConfig";

// API để lấy danh sách pricebook với phân trang và filter
export const getPricebooks = (filters) => {
  const url = "/price_books";
  
  // Tạo query parameters từ filters
  const params = {
    pageNo: filters?.pageNo || 0,
    pageSize: filters?.pageSize || 10,
    property: filters?.property || "id",
    direction: filters?.direction || "ASC",
    name: filters?.name || null
  };
  
  return axios.get(url, { params });
};

// API để lấy danh sách pricebook không phân trang
export const getAllPricebooks = () => {
  const url = "/price_books/list-all";
  return axios.get(url);
};

// API để thêm mới price book
export const addPricebook = (pricebookData) => {
  const url = "/price_books/add";
  return axios.post(url, pricebookData);
};

// API để cập nhật thông tin pricebook
export const updatePricebook = (pricebookId, pricebookData) => {
  const url = `/price_books/update/${pricebookId}`;
  return axios.put(url, pricebookData);
};

// API để xóa pricebook
export const deletePricebook = (pricebookId) => {
  const url = `/price_books/${pricebookId}`;
  return axios.delete(url);
};

// API để lấy chi tiết của một pricebook
export const getPricebookDetail = (pricebookId) => {
  const url = `/price_books/${pricebookId}`;
  return axios.get(url);
}; 
// API to add product into a Price Book
export const addProductPriceBook = (productData) => {
  const url = `/product_price_books/add`;
  return axios.post(url, productData);
};
// API to get all products
export const getAllProducts = () => {
  const url = "/products/list-all";
  return axios.get(url);
};
// API to delete a product pricebook
export const deleteProductPriceBook = (productPriceBookId) => {
  const url = `/product_price_books/delete/${productPriceBookId}`;
  return axios.delete(url);
};
// API to update a product pricebook
export const updateProductPriceBook = (productId, productData) => {
  const url = `/product_price_books/update/${productId}`;
  return axios.put(url, productData);
};
// API to get details of a product pricebook
export const getProductPriceBookDetail = (productId) => {
  const url = `/product_price_books/detail/${productId}`;
  return axios.get(url);
}; 
// API to get details of a product
export const getProductDetail = (productId) => {
  const url = `/products/detail/${productId}`;
  return axios.get(url);
}; 
// API to update product information
export const updateProduct = (productId, productData) => {
  const url = `/products/update/${productId}`;
  return axios.put(url, productData);
};
